























import { defineComponent } from '~/utils/nuxt3-migration'

export default defineComponent({
  props: {
    specification: { type: Object, required: true }
  },
  methods: {
    sendAnalyticsEvent(label: string) {
      this.$analytics.recordEvent({
        namespace: 'n_classified_view_specifications_category_anchor',
        label,
        action: 'click'
      })
    }
  }
})
